const SET_CARD_PAGES = 'customCards/SET_CARD_PAGES';
const SET_SELECTED = 'customCards/SET_SELECTED';
const SET_CARDS = 'customCards/SET_CARDS';
const ADD_CARDS = 'customCards/ADD_CARDS';

export default {
  SET_CARD_PAGES,
  SET_SELECTED,
  SET_CARDS,
  ADD_CARDS,
};



// WEBPACK FOOTER //
// ./src/app/custom-cards/store/mutation-types.js